module.exports = __webpack_public_path__ + "img/line_paytable.8f3c8abc.png";